import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { KYMW0300Model } from "../kymw0300.model";

@Injectable()
export class GetFeatureCodeListService extends PlessJsonResponderSub<any> {
  // VO
  vo = {
    OrderCode: '',
    MediumType: '',
  };

  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetFeatureCodeListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        FeatureCode: {
            condition:  {
                OrderCode: this.vo.OrderCode,
                MediumType: this.vo.MediumType,
            }
        }
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetFeatureCodeListService
   */
  execute(vo, successFunc: Function = null): void {
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('KYMW03GetFeatureCodeList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetFeatureCodeListService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
